import { render, staticRenderFns } from "./ReportActionButton.vue?vue&type=template&id=7946dbc2"
import script from "./ReportActionButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReportActionButton.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports